if (!customElements.get('product-form')) {
  customElements.define('product-form', class extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        HTMLFormElement.prototype.submit.call(this.form);
      });
    }
  });
}